module.exports = __webpack_public_path__ + "bf59c687bc6d3a70204d3944082c5cc0.ttf";